import servicio from '@/services/servicio-base'

const servicioEstatusPedido = {}

servicioEstatusPedido.getEstatusPedido = function(filas, pagina, orden){
    return servicio.get(`/estatus-pedido/pedidos-enc/${filas}/${pagina}/${orden}`)
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}

servicioEstatusPedido.getPedidosActivos = function(){
    return servicio.get(`/estatus-pedido/pedidos-activos`)
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}

servicioEstatusPedido.getPedidosAnteriores = function(fechaInicio, fechaFin, filas, pagina){
    return servicio.post('/estatus-pedido/pedidos-anteriores', {FechaInicio: fechaInicio,FechaFin: fechaFin,RowsPorPagina: filas,PaginaActual:pagina})
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}

servicioEstatusPedido.getDetallePedido = function(folio){
    return servicio.get(`/estatus-pedido/pedidos-det/${folio}`)
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}

export default servicioEstatusPedido